import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendorsUtil } from "../../../utility";
const useVendors = () => {
  const dispatch = useDispatch()
  const { all_vendors } = useSelector(state => state.orders)
  const [vendors, setVendors] = useState([]);
  const [modal, setModal] = useState(false);
  const [mergeModal, setMergeModal] = useState(false);
  const toggleCreateVendor = () => setModal(!modal);
  const toggleMergeModal = () => setMergeModal(!mergeModal);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState([]);
  const gettingVendors = () => {
    fetchVendorsUtil({
      page,
      search: searchValue ?? "",
      pageSize,
      setLoading,
      dispatch,
      setTotalPages,
    });
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingVendors()
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page, searchValue, pageSize]);
  useEffect(() => {
    let search = localStorage.getItem('vendorSearch') ?? "";
    const storedPage = parseInt(localStorage.getItem("vendorPage"), 10) || 1;
    setSearchValue(search)
    setPage(storedPage)
  }, [])
  useEffect(() => {
    setVendors(all_vendors ?? []);
  }, [all_vendors]);
  return {
    modal,
    setModal,
    mergeModal,
    toggleMergeModal,
    toggleCreateVendor,
    vendors,
    setVendors,
    selectedData,
    setSelectedData,
    selectedRows,
    setSelectedRows,
    searchValue,
    setSearchValue,
    data,
    setData,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages, gettingVendors
  };
};
export default useVendors;
